import styled from 'styled-components'
import { em } from 'polished'

import { BoxBase } from 'styles/components/layout'
import { Text } from 'shared/Typography'

export const Wrapper = styled.div`
  padding-top: 0;
  padding-bottom: ${em(40)};
  background-color: var(--color-W100);
  overflow: hidden;

  ${p => p.theme.mq.upLg} {
    padding-top: ${em(60)};
    padding-bottom: ${em(80)};
  }
`

export const Container = styled(BoxBase)`
  display: flex;
  flex-direction: column;

  ${p => p.theme.mq.downMd} {
  }
`

export const Title = styled(Text)`
  margin-bottom: ${em(16, 50)};
  text-align: center;
`

export const Description = styled(Text)`
  margin-bottom: ${em(40, 22)};
  text-align: center;
`

export const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${em(10)};
  justify-content: center;

  ${p => p.theme.mq.upLg} {
    flex-direction: row;
    gap: ${em(40)};
  }
`
